import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Theme } from "@mui/material";
import { usePatient } from "../state/patientContext";
import { PatientColorMap } from "../layout/patientColorMap";

//region [[ Styles ]]

const QuestionsProgressBarView = styled("div")(({ theme }) => ({
  width: "100%",
  maxHeight: "8px",
  // Avoid rtl from affecting its direction
  direction: "ltr",
}));

const ProgressBar = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  boxShadow: "2px -1px 10px 1px rgba(0,0,0,0.55);",
  marginBottom: "13px",
}));

const ProgressBarBg = styled("div")(({ theme }) => ({
  backgroundColor: "#e3e5e7",
  position: "absolute",
  width: "100%",
  height: "8px",
}));

const ProgressBarLine = styled("div")(
  ({ theme, value }: { theme?: Theme; value: string }) => ({
    width: value + "%",
    position: "absolute",
    height: "6px",
    transition: "all 0.5s ease-out",
    margin: "1px",
    borderRadius: "34px",
    background: `radial-gradient(94.93% 18985.79% at 4.27% 50%, ${PatientColorMap.GradLight} 0%, ${PatientColorMap.GradDark} 100%);`,
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface QuestionsProgressBarProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const QuestionsProgressBar = ({
  ...props
}: QuestionsProgressBarProps) => {
  const { progress } = usePatient();

  return (
    <QuestionsProgressBarView>
      <ProgressBar>
        <ProgressBarBg />
        <ProgressBarLine value={progress?.toString()} />
      </ProgressBar>
    </QuestionsProgressBarView>
  );
};
